import script from "./ViewMdaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMdaPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewMdaPage.vue?vue&type=style&index=0&id=3d5ed819&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5ed819"]])

export default __exports__